import { Box, Button, TextField } from '@mui/material'
import { Formik } from 'formik'
import useMediaQuery from '@mui/material/useMediaQuery'
import Header from '../../components/Header'

import React from "react"
import { useState } from "react"

import { useNavigate } from 'react-router-dom'

import * as Constants from '../../constants'

const AddUser = () => {
  const isNonMobile = useMediaQuery('(min-width:600px)')

  let navigate = useNavigate()
  const handleBack = () => {
    navigate('/team')
  }

  const [error, setError] = useState({ error: false, message: '' })
  const [success, setSuccess] = useState({ success: false, message: '' })

  const handleFormSubmit = (values) => {
    fetch(Constants.HOST + '/createOwner', {
      headers: { 'Content-Type': 'application/json' },
      method: 'POST',
      body: JSON.stringify({
        token: JSON.parse(localStorage.getItem('user_data')).token,
        id: values.id,
        name: values.name,
      }),
    })
      .then((response) => {
        if (response.status !== 400 && response.status !== 200) {
          setError({
            error: true,
            message: 'Erro de comunicação com o servidor',
          })
          setSuccess({ success: false, message: '' })
        } else {
          response.json().then((data) => {
            if (data.success) {
              setError({ error: false, message: '' })
              setSuccess({
                success: true,
                message: 'Usuário criado com sucesso',
              })
              values.name = ''
              values.id = ''
            } else {
              setSuccess({ success: false, message: '' })
              setError({ error: true, message: data.message })
            }
          })
        }
      })
      .catch(() => {
        setError({ error: true, message: 'Erro de comunicação com o servidor' })
        setSuccess({ success: false, message: '' })
      })
  }

  return (
    <Box m="20px">
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Header
          title="Criar novo proprietário"
          style={{ width: '100%', gridColumn: 'span 2' }}
        />
        <Button
          variant="contained"
          onClick={handleBack}
          sx={{ marginLeft: 'auto', gridColumn: 'span 1', height: '100%' }}
        >
          X
        </Button>
      </Box>

      {error.error && (
        <div style={{ color: 'red', margin: '10px 0' }}>{error.message}</div>
      )}
      {success.success && (
        <div style={{ color: 'green', margin: '10px 0' }}>
          {success.message}
        </div>
      )}

      <Formik onSubmit={handleFormSubmit} initialValues={initialValues}>
        {({ values, touched, handleBlur, handleChange, handleSubmit }) => (
          <form onSubmit={handleSubmit}>
            <Box
              display="grid"
              gap="30px"
              gridTemplateColumns="repeat(4, minmax(0, 1fr))"
              sx={{
                '& > div': { gridColumn: isNonMobile ? undefined : 'span 4' },
              }}
            >
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="ID"
                onBlur={handleBlur}
                name="id"
                value={values.id}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
              <TextField
                fullWidth
                variant="filled"
                type="text"
                label="Nome"
                onBlur={handleBlur}
                name="name"
                value={values.name}
                onChange={handleChange}
                sx={{ gridColumn: 'span 4' }}
                autoComplete="off"
              />
            </Box>
            <Box display="flex" justifyContent="end" mt="20px">
              <Button type="submit" color="secondary" variant="contained">
                Enviar
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </Box>
  )
}

const initialValues = {
  id: '',
  name: '',
}

export default AddUser
